/**
 * useBinOccupancy - Bin occupancy and priority polling hook
 *
 * Fetches and polls bin occupancy statistics for the current location.
 * Auto-refreshes every 30 seconds to show current occupancy and packer priority.
 *
 * IMPORTANT: Uses `refetchIntervalInBackground: false` to pause polling
 * when browser tab is not visible. See useBinStatus for rationale.
 *
 * @returns TanStack Query result with occupancy data including packerPriority
 */
import { trpc } from '@/lib/trpc';
import { useLocation } from '@/contexts/LocationContext';
import { skipToken } from '@tanstack/react-query';

export function useBinOccupancy() {
  const { selectedLocation } = useLocation();

  return trpc.bins.getBinOccupancy.useQuery(
    selectedLocation?.id
      ? { locationId: selectedLocation.id }
      : skipToken,
    {
      staleTime: 30_000,               // Consider fresh for 30s
      refetchInterval: 30_000,         // Poll every 30s (matches catcher/pretreat)
      refetchIntervalInBackground: false, // CRITICAL: Pause when tab hidden
    }
  );
}
